import { ShaderPass } from "three/addons/postprocessing/ShaderPass.js";
import { ShaderMaterial } from "three";

// 블룸 효과를 적용할 레이어 번호
export const BLOOM_SCENE = 1;

// 블렌드 모드 타입 정의
export type BlendMode = 'normal' | 'add' | 'screen' | 'multiply' | 'overlay';

// 렌더 모드 타입 정의
export type RenderMode = 'full' | 'bloom' | 'base';

// 파워 프리퍼런스 타입 정의
export type PowerPreference = "default" | "high-performance" | "low-power";

// 정밀도 타입 정의
export type Precision = "highp" | "mediump" | "lowp";

// 출력 색상 공간 타입 정의
export type OutputColorSpace = "srgb" | "linear" | "p3" | "rec2020";

// 섀도우 타입 정의
export type ShadowType = "BasicShadowMap" | "PCFShadowMap" | "PCFSoftShadowMap" | "VSMShadowMap";

// ShaderPass에서 사용할 interface 정의
export interface CustomShaderPass extends ShaderPass {
  material: ShaderMaterial & {
    uniforms: {
      [key: string]: { value: unknown };
    };
    fragmentShader: string;
    needsUpdate: boolean;
  }
}

// 블룸 파라미터 타입 (모든 필드 옵셔널)
export interface BloomParams {
  strength?: number;
  radius?: number;
  threshold?: number;
  exposure?: number;
}

// 블룸 혼합 파라미터 타입 (모든 필드 옵셔널)
export interface BlendParams {
  blendOpacity?: number;
  bloomStrength?: number;
  applyGamma?: boolean;
  blendMode?: BlendMode;
}

// 블룸 효과 설정 인터페이스 (옵셔널)
export interface BloomEffectConfig {
  bloomParams?: BloomParams;
  blendParams?: BlendParams;
}

// 렌더러 디버그 설정 인터페이스
export interface RendererDebugConfig {
  enableBloomDebug?: boolean;
  enableBlendDebug?: boolean;
  enableRenderModeDebug?: boolean;
}

// 렌더러 섀도우 설정 인터페이스 (옵셔널)
export interface RendererShadowConfig {
  enabled?: boolean;
  type?: ShadowType;
  autoUpdate?: boolean;
}

// 렌더러 기본 설정 인터페이스 (대부분 옵셔널)
export interface RendererBaseConfig {
  antialias?: boolean;
  powerPreference?: PowerPreference;
  alpha?: boolean;
  premultipliedAlpha?: boolean;
  precision?: Precision;
  depth?: boolean;
  stencil?: boolean;
  logarithmicDepthBuffer?: boolean;
  maxPixelRatio?: number;
  outputColorSpace?: OutputColorSpace;
  toneMappingExposure?: number;
  shadow?: RendererShadowConfig;
}

// 블룸 설정 인터페이스 (옵셔널)
export interface BloomConfig {
  enabled?: boolean;
  config?: BloomEffectConfig;
}

// 전체 렌더러 설정 인터페이스 (옵셔널)
export interface RendererConfig {
  renderer?: RendererBaseConfig;
  bloom?: BloomConfig;
} 